import { render, staticRenderFns } from "./InformasiLainnyaDetail-Desktop.vue?vue&type=template&id=14eed26a&scoped=true"
import script from "./InformasiLainnyaDetail-Desktop.vue?vue&type=script&lang=js"
export * from "./InformasiLainnyaDetail-Desktop.vue?vue&type=script&lang=js"
import style0 from "./InformasiLainnyaDetail-Desktop.vue?vue&type=style&index=0&id=14eed26a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14eed26a",
  null
  
)

export default component.exports